export default __webpack_public_path__ + "static/media/pagebanner1.15c88be1.jpg";